import Slider from 'react-slick'
import { Link } from 'react-router-dom'
import sponsorFirstImage from '../../media/sponsor_1.jpg'
import sponsorSecondImage from '../../media/sponsor-logo-1.png'
import sponsorThirdImage from '../../media/sponsor_3.jpg'
import sponsorFourthImage from '../../media/sponsor-logo-5.png'
import sponsorFifthImage from '../../media/sponsor-3.png'
import redBallLogo from '../../media/red-ball.png'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import '../../css/slider.css'

import { useMediaQuery } from 'react-responsive'

const logoData = [
  { src: sponsorFifthImage, alt: 'Logo 5', url: 'https://www.dclivery.com/' },
  { src: sponsorFirstImage, alt: 'Logo 1', url: 'https://www.amoneymatter.com/' },
  { src: sponsorThirdImage, alt: 'Logo 3', url: 'https://www.mazlogics.com/' },
  { src: sponsorFourthImage, alt: 'Logo 4', url: 'https://flycomforttravels.com/' },
  { src: sponsorSecondImage, alt: 'Logo 2', url: 'https://www.redzod.com/' }
  // ...add more as needed
]

export default function Sponsors() {
  const isMobile = useMediaQuery({ maxWidth: 767 })
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1024 })
  const isDesktop = useMediaQuery({ minWidth: 1025 })

  const mobileSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    swipeToSlide: true,
    slidesToShow: 2,
    slidesToScroll: 2
  }

  const tabletSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    swipeToSlide: true,
    slidesToShow: 2,
    slidesToScroll: 2
  }

  const desktopSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    swipeToSlide: true,
    slidesToShow: 4,
    slidesToScroll: 1
  }

  return (
    <>
      <div className='sponsor-section'>
        <div className='top-heading m-auto'>
          <img src={redBallLogo} alt='Red Ball Logo' />
          <span> Sponsors </span>
        </div>
        <h3> Our Sponsors and Contributors</h3>

        <div className='container logo-slider-container'>
          {isMobile && (
            <Slider {...mobileSettings} className='logo-carousel-sec'>
              {logoData.map((logo, index) => (
                <div key={index} className='logo-slide'>
                  <a href={logo.url} target='_blank' rel='noopener noreferrer'>
                    <img src={logo.src} alt={logo.alt} className='logo-image' />
                  </a>
                </div>
              ))}
            </Slider>
          )}
          {isTablet && (
            <Slider {...tabletSettings}>
              {logoData.map((logo, index) => (
                <div key={index} className='logo-slide'>
                  <a href={logo.url} target='_blank' rel='noopener noreferrer'>
                    <img src={logo.src} alt={logo.alt} className='logo-image' />
                  </a>
                </div>
              ))}
            </Slider>
          )}
          {isDesktop && (
            <Slider {...desktopSettings}>
              {logoData.map((logo, index) => (
                <div key={index} className='logo-slide'>
                  <a href={logo.url} target='_blank' rel='noopener noreferrer'>
                    <img src={logo.src} alt={logo.alt} className='logo-image' />
                  </a>
                </div>
              ))}
            </Slider>
          )}
        </div>
      </div>
    </>
  )
}
